import { render } from "./RadioItem.vue?vue&type=template&id=560a6264"
import script from "./RadioItem.vue?vue&type=script&lang=js"
export * from "./RadioItem.vue?vue&type=script&lang=js"

import "./RadioItem.vue?vue&type=style&index=0&id=560a6264&lang=scss"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__